import React from 'react';
import styles from '../search.scss';

const ClubsHeaderColumns = props => {
    const { filterType, clubs } = props;
    let sortValue = '';
    if (clubs.sort && clubs.sort.field) {
        sortValue = `${clubs.sort.field}_${clubs.sort.asc ? 'asc' : 'desc'}`;
    }
    const sortOptions = [
        { value: 'name_asc', label: 'Name: A to Z' },
        { value: 'name_desc', label: 'Name: Z to A' },
        { value: 'eventCount_asc', label: 'Events: Low to high' },
        { value: 'eventCount_desc', label: 'Events: High to low' },
        { value: 'memberCount_asc', label: 'Members: Low to high' },
        { value: 'memberCount_desc', label: 'Members: High to low' },
    ];

    const sort = (val) => {
        const sortBy = val.split('_');
        props.sortResults('clubs', sortBy[0], sortBy[1]);
    };

    // function sortDefaultDesc(type, field) {
    //     if (clubs.sort.field !== field || (clubs.sort.field === field && clubs.sort.asc)) {
    //         props.sortResults(type, field, 'desc');
    //     } else {
    //         props.sortResults(type, field, 'asc');
    //     }
    // }

    return (
        clubs.total > 0 ? (
            <div>
                <div className={`${styles.searchHeaders} d-none d-md-flex`} data-testid="search.clubs.column-headers">
                    <div className="flex-grow">
                        <div className="row">
                            <div
                                className={`col-md-5 ${styles.searchHeaderColumn} ${filterType && styles.clickable} ${filterType && clubs.sort.field === 'name' ? 'active' : ''}`}
                                onClick={() => { return filterType ? props.sortResults('clubs', 'name') : null; }}
                                data-testid="search.clubs.column-header.name"
                            >
                                {(filterType ? <span data-testid="search.clubs.column-header.name-label">Name <i className={`uts ${clubs.sort.field === 'name' && !clubs.sort.asc ? 'uts-expand' : 'uts-collapse'}`} /></span> : <span data-testid="search.clubs.column-header.name-label">Clubs</span>)}
                            </div>
                            <div className={`col-md-3 ${styles.searchHeaderColumn}`} data-testid="search.clubs.column-header.location">Location</div>
                            <div className={'col-md-4'}>
                                <div className="row w-100">
                                    <div
                                        className={`col-sm-4 ${styles.searchHeaderColumn} ${filterType && styles.clickable} ${filterType && clubs.sort.field === 'eventCount' ? 'active' : ''}`}
                                        onClick={() => { return filterType ? props.sortResults('clubs', 'eventCount') : null; }}
                                        data-testid="search.clubs.column-header.events"
                                    >
                                        {(filterType ? <span data-testid="search.clubs.column-header.events-label">Events <i className={`uts ${clubs.sort.field === 'eventCount' && !clubs.sort.asc ? 'uts-expand' : 'uts-collapse'}`} /></span> : <span data-testid="search.clubs.column-header.events-label">Events</span>)}
                                    </div>
                                    <div
                                        className={`col-sm-4 ${styles.searchHeaderColumn} ${filterType && styles.clickable} ${filterType && clubs.sort.field === 'memberCount' ? 'active' : ''}`}
                                        onClick={() => { return filterType ? props.sortResults('clubs', 'memberCount') : null; }}
                                        data-testid="search.clubs.column-header.members"
                                    >
                                        {(filterType ? <span data-testid="search.clubs.column-header.members-label">Members <i className={`uts ${clubs.sort.field === 'memberCount' && !clubs.sort.asc ? 'uts-expand' : 'uts-collapse'}`} /></span> : <span data-testid="search.clubs.column-header.members-label">Members</span>)}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={`${styles.searchHeaders} d-block d-md-none`} data-testid="search.clubs.column-headers-mobile">
                    {filterType ? (
                        <div className={``} data-testid="search.clubs.sort-by-wrapper">
                            Sort by
                            <select
                                className="inline-input"
                                value={sortValue}
                                onChange={(e) => sort(e.target.value)}
                                data-testid="search.clubs.sort-select"
                            >
                                <option value="">Relevance</option>
                                {sortOptions.map((option, i) => <option value={option.value} key={`clubSort${i}`}>{option.label}</option>)}
                            </select>
                        </div>
                    ) : 'Clubs'}
                </div>
            </div>
        ) : <div />
    );
};

export default ClubsHeaderColumns;
